import React, { useMemo } from 'react';
import {
  Chart as ChartJS, ArcElement, Tooltip, Legend,
} from 'chart.js';
import { Doughnut } from 'react-chartjs-2-v4';

import {
  cssvar, tertiary, tertiary800, tertiary600,
} from 'components/new_ui/Colors';
import LoadingPlaceholder from 'components/new_ui/WaitLayers/LoadingPlaceholder';
import chartOptions from 'components/utils/chartOptions';
import { useContext } from 'components/Managers/Dashboard/Context';
import useSessionsStatistics from 'components/Managers/Dashboard/Hooks/useSessionsStatistics';
import Statistic from 'components/Managers/Dashboard/Views/Statistic';

import EmptyChart from './EmptyChart';

ChartJS.register(ArcElement, Tooltip, Legend);

export default function SessionsStatistics() {
  const { state: { filters } } = useContext();
  const { data: sessions, loading } = useSessionsStatistics(filters);

  const statistics = useMemo(() => (
    {
      labels: ['Completed', 'Not Started', 'In Progress'],
      datasets: [
        {
          data: [
            sessions.percent.Completed,
            sessions.percent['Not Started'],
            sessions.percent['In Progress'],
          ],
          backgroundColor: [cssvar(tertiary), cssvar(tertiary800), cssvar(tertiary600)],
        },
      ],
    }
  ), [sessions]);

  return (
    <div className="h-100 border border-2 rounded-3 p-3">
      <h5 className="mb-4">Sessions Completed</h5>

      {loading ? <LoadingPlaceholder /> : (
        <>
          {sessions.total === 0 ? (
            <EmptyChart />
          ) : (
            <Doughnut data={statistics} options={chartOptions} />
          )}

          <Statistic
            label="Completed"
            value={sessions.percent.Completed}
            iconBackgroundColor={tertiary}
          />

          <Statistic
            label="Not Started"
            value={sessions.percent['Not Started']}
            iconBackgroundColor={tertiary800}
          />

          <Statistic
            label="In Progress"
            value={sessions.percent['In Progress']}
            iconBackgroundColor={tertiary600}
          />
        </>
      )}
    </div>
  );
}
